import { put, takeLatest, all, select } from 'redux-saga/effects';
import { LOCATION_CHANGE } from 'connected-react-router';

import { getWhitelabelDomain } from 'services/config/selectors';
import { getParsedLocation, getWhitelabelKey } from './selectors';
import { updateWhitelabelKey } from './duck';

export function* handleLocationChange() {
    const whitelabelDomain = yield select(getWhitelabelDomain);
    const parsedLocation = yield select(getParsedLocation);
    const currentWhitelabelKey = yield select(getWhitelabelKey);
    let nextWhitelabelKey;
    let forceUpdate = false;
    let isAtWhitelabelDomain = false;

    if (!whitelabelDomain) {
        // do nothing because whitelabeling hasn't been configured
        return;
    }

    if (parsedLocation.hostname.endsWith(whitelabelDomain)) {
        isAtWhitelabelDomain = true;
        if (parsedLocation.hostname !== whitelabelDomain) {
            // is whitelabel
            nextWhitelabelKey = parsedLocation.hostname.replace(new RegExp(`.${whitelabelDomain}$`), '');
        } else {
            // is whitelabel at main domain
            // this will be a 404 eventually
            forceUpdate = true;
            nextWhitelabelKey = null;
        }
    } else {
        nextWhitelabelKey = null;
    }

    if (forceUpdate || currentWhitelabelKey !== nextWhitelabelKey) {
        yield put(updateWhitelabelKey({
            whitelabelKey: nextWhitelabelKey,
            isWhitelabel: !!nextWhitelabelKey || parsedLocation.hostname === whitelabelDomain
        }));
    }

    if (!isAtWhitelabelDomain && /goodway group/i.test(document.title) === false) {
        document.title = `${document.title} | Goodway Group`;
    }
}

export default function* routerSagas() {
    yield all([
        takeLatest(LOCATION_CHANGE, handleLocationChange),
    ]);
}



// WEBPACK FOOTER //
// ./src/services/router/saga.js